import { v4 as uuidV4 } from "uuid"

const getInternalId = () => {
    return `internal-notification-${uuidV4()}`
}

export default getInternalId
